import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconEraser"><Path fillRule="evenodd" clipRule="evenodd" d="M13.9697 1.96967C14.2626 1.67678 14.7374 1.67678 15.0303 1.96967L22.0303 8.96967C22.3208 9.26013 22.3236 9.7302 22.0365 10.0241L11.5365 20.7741C11.3954 20.9185 11.202 21 11 21H8.25C8.05109 21 7.86032 20.921 7.71967 20.7803L1.96967 15.0303C1.67678 14.7374 1.67678 14.2626 1.96967 13.9697L13.9697 1.96967ZM3.56066 14.5L8.56066 19.5H10.6842L12.5397 17.6003L6.5 11.5607L3.56066 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraser;
